module.exports = __webpack_public_path__ + "0513c57821ea714890eb5148edc6f8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Technology/top-right.jpg
// module id = 874
// module chunks = 1